"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDevicePixelRatio = exports.getHeight = exports.getWidth = exports.getScaledResolution = exports.getResolution = void 0;

var _mobileDetectionHelper = require("./mobile-detection-helper");

/**
 * Resolved the device its screen resolution.
 */
var getResolution = function getResolution() {
  var width = getWidth() * getDevicePixelRatio();
  var height = getHeight() * getDevicePixelRatio();
  return "".concat(width, "x").concat(height);
};

exports.getResolution = getResolution;

var getScaledResolution = function getScaledResolution(modifier) {
  var width = Math.round(getWidth() * getDevicePixelRatio() * modifier);
  var height = Math.round(getHeight() * getDevicePixelRatio() * modifier);
  return "".concat(width, "x").concat(height);
};

exports.getScaledResolution = getScaledResolution;

var getWidth = function getWidth() {
  return window.screen.width;
};

exports.getWidth = getWidth;

var getHeight = function getHeight() {
  return window.screen.height;
};

exports.getHeight = getHeight;

var getDevicePixelRatio = function getDevicePixelRatio() {
  if ((0, _mobileDetectionHelper.isIpad)() || (0, _mobileDetectionHelper.isDeviceTablet)() || (0, _mobileDetectionHelper.smDown)()) {
    return window.devicePixelRatio;
  } // We don't want to scale for iMacs, they look fine just like they are.


  return 1.0;
};

exports.getDevicePixelRatio = getDevicePixelRatio;